import { MY_AD } from "../constants/ActionTypes";

const initialADState = {
    MY_AD_LISTS: null
};

export default function ( state = initialADState, action = {} ){
  switch( action.type ){
    //查询收货地址列表
    case MY_AD.MY_AD_LISTS:
      return Object.assign({}, state, {
        MY_AD_LISTS: action.MY_AD_LISTS
      });
    //设置默认地址
    case MY_AD.MY_AD_DEFAULT:
      return Object.assign({}, state, {
        MY_AD_DEFAULT: action.MY_AD_DEFAULT
      });

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./common/reducers/myAccountAddress.js